/** 这里是 State */

export default {

    menuCollapse: false, // 左侧导航栏折叠状态
    menus: [] // 导航栏内容
}


// WEBPACK FOOTER //
// ./src/store/state.js